export default __webpack_public_path__ + "static/media/Left004.74613e3d.png";